import React, { useEffect, useState } from "react";
import "./Header.css";
import { useLocation } from "react-router-dom";
const Header = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Home");

  useEffect(() => {
    if (location.pathname === "/") {
      setActiveTab("Home");
    } else if (location.pathname === "/about") {
      setActiveTab("About");
    }

    return () => {};
  }, []);

  return (
    <div className="main_header">
         <h1>Portfolio</h1>
      <div className="btn">
      <a
        className={`${activeTab === "Home" ? "active" : ""}`}
        href="/"
        onClick={() => setActiveTab("Home")}
      >
        Home
      </a>
      <a href="https://storage.cloudconvert.com/tasks/a601474b-6a6e-4af1-95ce-eac291c9827e/Web%201920%20%E2%80%93%203.pdf?AWSAccessKeyId=cloudconvert-production&Expires=1642741465&Signature=VMEoViYfwgVMXseqWFpxFUNd8SQ%3D&response-content-disposition=attachment%3B%20filename%3D%22Web%201920%20%3F%203.pdf%22%3B%20filename%2A%3DUTF-8%27%27Web%25201920%2520%25E2%2580%2593%25203.pdf&response-content-type=application%2Fpdf">
          Resume
        </a>
      </div>
    </div>
  );
};

export default Header;
